import React, { Component } from "react";
import { decideText, propConcate, renderFasta } from "./ModuleREF_vista";

export class RenderExonsFull extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeView: "aaseq", // default view
    };
  }

  // Single function to handle all toggles
  toggleView(view) {
    this.setState({ activeView: view });
    this.props.handleUpdateInfRend(view);
  }

  render() {
    const { exOn: exonHash, transwhole: trans, domset } = this.props;
    const { activeView } = this.state;

    let aaVista = "";
    trans.exonsIds.split(",").forEach((ex) => {
      aaVista += exonHash[parseInt(ex)].aaseq;
    });

    let sseqVista = "";
    trans.exonsIds.split(",").forEach((ex) => {
      sseqVista += propConcate(trans.id, domset, exonHash[parseInt(ex)], "ssseq");
    });

    return (
      <div className="overflow-hidden" style={{ border: "double 1px lightgray", padding: "10px 5px 5px 10px" }}>
        <div className="h5">
          <span>Isoform:</span>
          <span
            className="badge align-center mx-2 my-3 h5"
            style={{ color: "#00303f", background: "#e9e9e9", borderLeft: "5px solid #00303f" }}
          >
            {trans.tId}
          </span>
        </div>
        <div className="row">
          <div className="col" style={{ flexDirection: "row", overflowX: "scroll" }}>
            <div className="d-flex flex-wrap" style={{ fontFamily: "monospace", wordWrap: "break-word" }}>
              {activeView === "fasta" ? renderFasta(trans.tId, trans.exonsIds, exonHash) : null}
              {activeView !== "fasta" &&
                trans.exonsIds.split(",").map((ex) => (
                  <div key={parseInt(trans.id.toString() + ex)}>
                    <span
                      style={{ fontSize: 20, wordWrap: "break-word" }}
                      onMouseLeave={() => this.props.removeAlert()}
                      onMouseEnter={() =>
                        this.props.addAlert(this.props.exonAlerts[exonHash[parseInt(ex)].exId])
                      }
                    >
                      {decideText(activeView, trans.id, domset, exonHash[parseInt(ex)])}
                    </span>
                  </div>
                ))}
            </div>
            <div className="container mt-2 mb-2 pb-2">
              <button
                onClick={() => this.toggleView("aaseq")}
                className="m-2 btn px-2 py-1 btn-md text-decoration-none"
                title="Exons in blocks"
                style={{ background: activeView === "aaseq" ? "#a7d2cb" : "#FFFFFF", color: activeView === "aaseq" ? "black" : "#666666" }}
              >
                Sequence
              </button>
              <button
                onClick={() => this.toggleView("fasta")}
                className="mx-2 my-0 px-2 py-1 btn btn-md"
                style={{ background: activeView === "fasta" ? "#a7d2cb" : "#FFFFFF", color: activeView === "fasta" ? "black" : "#666666" }}
              >
                Fasta
              </button>
              <button
                onClick={() => this.toggleView("ss")}
                className="m-2 btn px-2 py-1 btn-md text-decoration-none"
                title="Secondary structure"
                style={{ background: activeView === "ss" ? "#a7d2cb" : "#FFFFFF", color: activeView === "ss" ? "black" : "#666666" }}
              >
                Show SS
              </button>
              <button
                onClick={() => this.toggleView("dom")}
                className="m-2 px-2 py-1 btn btn-md text-decoration-none"
                title="Pfam domains"
                style={{
                  background: activeView === "dom" ? "#a7d2cb" : "#FFFFFF",
                  color: activeView === "dom" ? "black" : "#666666"
                }}
              >
                Show Dom
              </button>
              <button
                onClick={() => this.toggleView("dis")}
                className="m-2 px-2 py-1 btn btn-md text-decoration-none"
                title="Disordered region"
                style={{
                  background: activeView === "dis" ? "#a7d2cb" : "#FFFFFF",
                  color: activeView === "dis" ? "black" : "#666666"
                }}
              >
                Show Dis
              </button>
            </div>
          </div >
        </div >
      </div >
    );
  }
}

export default RenderExonsFull;